import React from "react";

interface MetricValueWithExternalProps {
  value: number;
  external?: number;
  /** Rótulo curto ao lado do número externo */
  externalSuffix?: string;
}

export const MetricValueWithExternal: React.FC<
  MetricValueWithExternalProps
> = ({ value, external, externalSuffix = "ext" }) => {
  if (external == null || external <= 0) {
    return <>{value}</>;
  }

  return (
    <span className="inline-flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5">
      <span>{value}</span>
      <span
        className="text-sm font-semibold text-amber-700 sm:text-base"
        title={`${external} ${externalSuffix === "ext" ? "externas" : externalSuffix}`}
      >
        (+{external} {externalSuffix})
      </span>
    </span>
  );
};

export default MetricValueWithExternal;
